export default __webpack_public_path__ + "static/logo-a1dafce07d59c15244126c7d39541645.png";